// Did the page's initial data fail to load?
//
// Takes the Promise.allSettled results of the fetch hooks. A hook rejects when
// the request errored, and resolves `undefined` when the server answered
// status "failed" — both mean the data never arrived. An empty answer (a new
// client with no profile yet) resolves the result object, so it is NOT a
// failure: resolveInitialStep handles that by landing on the Flow step.
//
// Without this check a failed load rendered the steps with no profile and no
// flows, so resolveInitialStep fell through to an empty "select a
// verification type" screen (TKT-351).
export const preloadFailed = (settled = []) =>
    settled.some(r => r.status === "rejected" || r.value === undefined);
